import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { Users, Settings } from 'lucide-react';

const Container = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #00d4aa 0%, #00b894 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

const WelcomeCard = styled.div`
  background: white;
  border-radius: 16px;
  padding: 48px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  text-align: center;
  max-width: 500px;
  width: 100%;
`;

const Title = styled.h1`
  font-size: 32px;
  font-weight: 700;
  color: #333;
  margin: 0 0 16px;
`;

const Subtitle = styled.p`
  font-size: 18px;
  color: #666;
  margin: 0 0 48px;
  line-height: 1.5;
`;

const ButtonContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-bottom: 32px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const AccessButton = styled.button`
  padding: 32px 24px;
  background: white;
  border: 2px solid #e9ecef;
  border-radius: 12px;
  text-align: center;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    border-color: #00d4aa;
    box-shadow: 0 8px 25px rgba(102, 126, 234, 0.15);
    transform: translateY(-2px);
  }
`;

const ButtonIcon = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: #00d4aa20;
  color: #00d4aa;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
`;

const ButtonTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0 0 8px;
`;

const ButtonDescription = styled.p`
  font-size: 14px;
  color: #666;
  margin: 0;
  line-height: 1.4;
`;

const Footer = styled.div`
  padding-top: 32px;
  border-top: 1px solid #e9ecef;
  font-size: 14px;
  color: #666;
`;

export const HomePage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <WelcomeCard>
        <Title>Clube de Fidelidade</Title>
        <Subtitle>
          Plataforma de fidelização com pontos, níveis, campanhas automáticas e inteligência de retenção
        </Subtitle>

        <ButtonContainer>
          <AccessButton onClick={() => navigate('/customer/login')}>
            <ButtonIcon>
              <Users size={24} />
            </ButtonIcon>
            <ButtonTitle>Sou Cliente</ButtonTitle>
            <ButtonDescription>
              Acesse com CPF + OTP para ver seus pontos e resgatar prêmios
            </ButtonDescription>
          </AccessButton>

          <AccessButton onClick={() => navigate('/app/login')}>
            <ButtonIcon>
              <Settings size={24} />
            </ButtonIcon>
            <ButtonTitle>Sou Empresa</ButtonTitle>
            <ButtonDescription>
              Acesse o painel para gerenciar pontos, tiers, CRM e benefícios avançados
            </ButtonDescription>
          </AccessButton>
        </ButtonContainer>

        <Footer>
          <p>Escolha sua forma de acesso ao sistema</p>
        </Footer>
      </WelcomeCard>
    </Container>
  );
};
